import { createStore, setStateHelper } from "@neonumy/ant-design";
import { StoreApi, UseBoundStore } from "zustand";

const initialState = {
  categoryId: undefined,
  currencyOptions: [],
  companySettings: undefined,
  companyData: undefined,
  currency: undefined,
  companySettingsLoading: false,
  currencyLoading: false,
  companySelected: undefined,
  accountingFirmSelected: undefined,
  currentCycle: undefined,
  companyAccountingSettings: undefined,
};

interface CoreStore {
  resetStore: () => void;
  categoryId: ID;
  currency: CurrencyType | undefined;
  currentCycle: CurrentCycle | undefined;
  companySettings: CompanySettingsType | undefined;
  companyAccountingSettings: CompanyAccountingSettingsType | undefined;
  companyData: CompanyDataType | undefined;
  currencyOptions: CurrencyOptionsType[];
  companySettingsLoading: boolean;
  currencyLoading: boolean;
  companySelected: CompanySelected | undefined;
  accountingFirmSelected: AccountingFirmSelected | undefined;
  setCategoryId: (categoryId: ID) => void;
  setCurrency: (currency: CurrencyType) => void;
  setCompanySettings: (companySettings: CompanySettingsType) => void;
  setCompanyAccountingSettings: (companyAccountingSettings: CompanyAccountingSettingsType) => void;
  setCompanyData: (companyData: CompanyDataType) => void;
  setCurrencyOptions: (currencyOptions: CurrencyOptionsType[]) => void;
  setCompanySettingsLoading: (companySettingsLoading: boolean) => void;
  setCompanySelected: (companySelected: CompanySelected) => void;
  setAccountingFirmSelected: (accountingFirmSelected: AccountingFirmSelected) => void;
  setCurrentCycle: (currentCycle: CurrentCycle) => void;
}

const useCoreStore: UseBoundStore<StoreApi<CoreStore>> = createStore<CoreStore>(
  (set: (fn: (draft: CoreStore) => void) => void) => ({
    ...initialState,
    resetStore: () => {
      set(state => ({
        ...initialState,
        companySelected: state.companySelected,
        accountingFirmSelected: state.accountingFirmSelected,
      }));
    },
    setCategoryId: (categoryId: ID) => {
      setStateHelper("categoryId", categoryId, set);
    },
    setCurrency: (currency: CurrencyType) => {
      setStateHelper("currency", currency, set);
    },
    setCompanySettings: (companySettings: CompanySettingsType) => {
      setStateHelper("companySettings", companySettings, set);
    },
    setCompanyAccountingSettings: (companyAccountingSettings: CompanyAccountingSettingsType) => {
      setStateHelper("companyAccountingSettings", companyAccountingSettings, set);
    },
    setCompanyData: (companyData: CompanyDataType) => {
      setStateHelper("companyData", companyData, set);
    },
    setCurrencyOptions: (currencyOptions: CurrencyOptionsType[]) => {
      setStateHelper("currencyOptions", currencyOptions, set);
    },
    setCurrentCycle: (currentCycle: CurrentCycle) => {
      setStateHelper("currentCycle", currentCycle, set);
    },
    setCompanySettingsLoading: (companySettingsLoading: boolean) => {
      setStateHelper("companySettingsLoading", companySettingsLoading, set);
    },
    setCurrencyLoading: (currencyLoading: boolean) => {
      setStateHelper("currencyLoading", currencyLoading, set);
    },
    setCompanySelected: (companySelected: CompanySelected) => {
      setStateHelper("companySelected", companySelected, set);
    },
    setAccountingFirmSelected: (accountingFirmSelected: AccountingFirmSelected) => {
      setStateHelper("accountingFirmSelected", accountingFirmSelected, set);
    },
  }),
);

export default useCoreStore;
